export const Locale = {
    CS: 'cs',
    SK: 'sk',
    EN: 'en',
    DE: 'de',
    DE_AT: 'de-AT',
} as const

export type Locale = (typeof Locale)[keyof typeof Locale]

export const LocaleLanguage = {
    CS_CZ: 'cs-CZ',
    SK_SK: 'sk-SK',
    EN_US: 'en-US',
    DE_DE: 'de-DE',
    DE_AT: 'de-AT',
} as const

export type LocaleLanguage = (typeof LocaleLanguage)[keyof typeof LocaleLanguage]
